function waitForElement(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

function parseJSONByAttribute(attr, fallback = []) {
    try {
        const el = document.querySelector(attr);
        return el ? JSON.parse(el.textContent.trim()) : fallback;
    } catch (e) {
        console.warn('Failed to parse JSON', e);
        return fallback;
    }
}

async function createVariantsMap() {
   // Get Variants Data from one of the HTML elements of the page
   const dataVariantJsonEl = await waitForElement('[data-variant-json]');
   if (dataVariantJsonEl){
        variantsData = parseJSONByAttribute('[data-variant-json]');
        // Create a Map to make it easy to lookup the SKUs {variantId -> variantSku}
        variantsSkuMap = new Map(
            variantsData.map(v => [String(v.id), String(v.sku)])
        );
   }
}

function disableAtcButton() {
    const atcButtonEls = document.querySelectorAll('button.product-form__cart-submit');
    if (atcButtonEls.length) {
        atcButtonEls.forEach(atcButtonEl => {
            atcButtonEl.setAttribute("disabled","disabled");
            const textEl = atcButtonEl.querySelector('[data-add-to-cart-text]');
            textEl.innerHTML = "Sold out";
        });
    }
}

function enableAtcButton() {
    const atcButtonEls = document.querySelectorAll('button.product-form__cart-submit');
    if (atcButtonEls.length) {
        atcButtonEls.forEach(atcButtonEl => {
            atcButtonEl.removeAttribute("disabled","disabled");
            const textEl = atcButtonEl.querySelector('[data-add-to-cart-text]');
            textEl.innerHTML = "Add to Cart";
        });
    }
}

/*
 * List of SKUs of Deos for which Recharge Subscription widget is to be hidden:
 * - PF - Coconut & Vanilla (SKU: 80797018)
 * - PF - Cucumber & Mint (SKU: 80804325)
 * - PF - Eucalyptus & Mint (SKU: 80797019)
 * - PF - Lilac & White Tea (SKU: 80797020)
 * - Sensitive Unscented (SKU: 80797017)
*/
let pfSkusToHideSubs = ["80797018", "80804325", "80797019", "80797020", "80797017"];
let variantsData = [];
let variantsSkuMap = [];
let deodorantAtcButtonWrapperEl = null;

    // Event: Page Content Load
document.addEventListener('DOMContentLoaded', function(loadEvt) {
    try {
        deodorantAtcButtonWrapperEl = document.querySelector('.product-item__quick-add-beneath > [data-product-id="8675473653934"]');
        if (deodorantAtcButtonWrapperEl) {
            const deodorantAtcButtonEl = deodorantAtcButtonWrapperEl.querySelector('button.product-item__quick-add');
            deodorantAtcButtonEl.addEventListener('click', function(clickEvt) {
                createVariantsMap();
            });
        }
    } catch (error) {
        console.log(error);
    }
});

    // Event: Variant Change
document.addEventListener("product:variant-change", function (evt) {
    const variantId = String(evt.detail.variant.id);
    // Get current or default variant SKU
    const variantSku = String(variantsSkuMap.get(variantId)) || "";
    // Check whether the ATC button should be hidden for the current variant SKU or not
    if (pfSkusToHideSubs.includes(variantSku)) {
        disableAtcButton();
    } else {
        enableAtcButton();
    }
});
